import React, { useEffect, useState } from 'react'
import { CircularProgress, Grid, Typography } from '@material-ui/core'
import { usePericiandoService } from 'hooks/usePericiandoService'
import moment from 'moment'
import localization from 'moment/locale/pt-br'
import useStyles from './styles'

export const DetailPanel = (props) => {
  const { idPericiandoSelecionado } = props
  moment.locale('pt-br', localization)
  const periciandoService = usePericiandoService()
  const [processandoPericiando, setProcessandoPericiando] = useState(false)
  const [periciando, setPericiando] = useState(null)
  const classes = useStyles()

  useEffect(() => {
    const fetchPericiando = async () => {
      const response = await periciandoService.listarPericiandoDetalhadoAsync(idPericiandoSelecionado, setProcessandoPericiando)
      setPericiando(response)
    }

    if (idPericiandoSelecionado && idPericiandoSelecionado >= 0) {
      fetchPericiando()
    }
  }, [idPericiandoSelecionado])

  return (
    <div>
      {processandoPericiando || !periciando ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <Grid container className={classes.container} spacing={1}>
          <Grid item md={4} sm={6} xs={12} className={classes.infoBlock}>
            <Typography className={classes.label}>
              {periciando.casosPeric?.length > 1 ? 'Casos relacionados' : 'Caso relacionado'}
            </Typography>
            <Typography className={classes.value}>
              {periciando.casosPeric?.length
                ? periciando.casosPeric.map((c) => c.identificador).join(', ')
                : periciando.caso?.identificador || '-'}
            </Typography>
          </Grid>

          <Grid item md={4} sm={6} xs={12} className={classes.infoBlock}>
            <Typography className={classes.label}>Alcunha</Typography>
            <Typography className={classes.value}>
              {periciando.alcunha || 'Não informado'}
            </Typography>
          </Grid>

          <Grid item md={4} sm={6} xs={12} className={classes.infoBlock}>
            <Typography className={classes.label}>Ocupação</Typography>
            <Typography className={classes.value}>
              {periciando.ocupacao || 'Não informado'}
            </Typography>
          </Grid>

          <Grid item md={4} sm={6} xs={12} className={classes.infoBlock}>
            <Typography className={classes.label}>Endereço</Typography>
            <Typography className={classes.value}>
              {periciando.endereco
                ? `${periciando.endereco}${periciando.numeroResidencial ? `, ${periciando.numeroResidencial}` : ''}`
                : 'Não informado'}
            </Typography>
          </Grid>

          <Grid item md={4} sm={6} xs={12} className={classes.infoBlock}>
            <Typography className={classes.label}>Filiações</Typography>
            <Typography className={classes.value}>
              {periciando.filiacoes && periciando.filiacoes.length > 0
                ? periciando.filiacoes.join(', ')
                : 'Não informado'}
            </Typography>
          </Grid>

          <Grid item md={4} sm={6} xs={12} className={classes.infoBlock}>
            <Typography className={classes.label}>Classificação quanto à natureza da solicitação</Typography>
            <Typography className={classes.value}>
              {periciando.classificacao || 'Não informado'}
            </Typography>
          </Grid>
        </Grid>
      )}
    </div>
  )
}
